const watchlistVersion = window.localStorage.getItem('watchlist_version');
if (!watchlistVersion) {
    window.localStorage.setItem('watchlist_version', '1.0.0');
    window.localStorage.removeItem('vuex');
}
